module.exports = __webpack_public_path__ + "img/1_3.ef569eb3.png";